import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../../utils/request';


export class CSPCFamilyApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            successMessage:"",
        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId"); 
        this.loadPage(tenantId, commonParamater);
    };
    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/CSPC/CSPCSubmitRelativesByHR", { params: params })
            .then(res => {
                let errorMessage = "";
                let successMessage = "";
                if (res.data.code != "200") {
                    errorMessage = "流程发起失败！错误信息：" + res.data.message;
                } else {
                    successMessage = res.data.data;
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, successMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "获取员工详情跳转链接异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (<div style={{ textAlign: "center", padding: "32px" }}>
                    <p style={{ color: "green" }}>流程后台执行中。</p>
                    <p style={{ color: "green" }}>发起结果将发送给该岗位招聘负责人。</p>
                    <p style={{ color: "green" }}>请关闭当前页面，并关注待办或通知。</p>
                </div>)
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}